import { make } from 'vuex-pathify'
import { getGeoIP, getFlightEstimate, queryLocations } from '@/services/api'

const state = {
  userLocation: null,
  places: [],
  suggestedAirports: [],
  order: [],
  selectedPlace: null,
  placeAirports: [],
  fromAirport: null,
  toAirport: null,
  estimate: null,
}

const getters = {
  firstSuggestedAirport: state => state.suggestedAirports.length ? state.suggestedAirports[0] : null
}

const mutations =  {
  ...make.mutations(state),
}

const actions = {
  async fetchUserLocation ({ commit }) {
    const { data } = await getGeoIP()
    commit('SET_USER_LOCATION', data)
  },
  async fetchFlightEstimate ({ state, commit }) {
    const { data: { data } } = await getFlightEstimate(state.fromAirport.icao_code, state.toAirport.icao_code)
    commit('SET_ESTIMATE', data)
  },
  async fetchPlaces ({ state, commit }, input) {
    const { data: { airports, places, order } } = await queryLocations(input)
    // console.log(airports)
    // console.log(places)
    // if (!places.length && !airports.length) return

    const otherAirport = state.fromAirport || state.toAirport
    let filteredAirports = airports

    if (otherAirport) {
      // Prevent same 'to' and 'from' airport
      filteredAirports = airports.filter(airport => airport.icao_code !== otherAirport.icao_code)
    }

    commit('SET_SUGGESTED_AIRPORTS', [...filteredAirports])
    commit('SET_PLACES', [...places])
    commit('SET_ORDER', [...order])
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
